import { useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

import ProgressBar from "../ProgressBar/ProgressBar";
import Typography from "../Typography/Typography";
import AuthPageShell from "../AuthPageShell/AuthPageShell";
import shellStyles from "../AuthPageShell/AuthPageShell.module.scss";
import styles from "./Navbar.module.scss";

import { ReactComponent as ArrowLeft } from "../../assets/arrowLeft.svg";

const Navbar = () => {
	const navigate = useNavigate();
	const { pathname } = useLocation();
	const [shellFooter, setShellFooter] = useState(null);

	const handleBackClick = () => {
		switch (pathname) {
			case "/register/validate-identity":
				navigate("/");
				break;

			case "/register/personal-data":
				navigate("/register/validate-identity");
				break;

			case "/register/last-steps":
				navigate("/register/personal-data");
				break;

			default:
				navigate();
				break;
		}
	};

	return (
		<AuthPageShell footer={shellFooter}>
			<div className={shellStyles.authTitleContainer}>
				{pathname !== "/register/personal-data" && (
					<ArrowLeft
						className={shellStyles.authTitleArrow}
						onClick={handleBackClick}
					/>
				)}
				<div
					className={shellStyles.authTitleTxt}
					style={{
						margin:
							pathname !== "/register/personal-data"
								? "17px"
								: "0",
					}}
				>
					<Typography variant="h5">
						Únete a Amigos Juan Valdez
					</Typography>
				</div>
			</div>

			<div className={styles.navbarProgressBarContainer}>
				<ProgressBar></ProgressBar>
			</div>
			<Outlet context={{ setShellFooter }} />
		</AuthPageShell>
	);
};

export default Navbar;
